import { Injectable } from '@angular/core';

interface IConfirmation {
    header?: string;
    message: string;
    accept: Function;
    reject?: Function;
    confirmBtnText?: string;
    rejectBtnText?: string;
    subTitle?: string;
    footerNote?: string;
    showClose?: boolean;
}
@Injectable()
export class ConfirmationService {
    public showPopup: boolean;
    public header: string;
    public message: string;
    public accept: Function;
    public reject: Function;
    public confirmBtnText: string;
    public rejectBtnText: string;
    private _confirm: IConfirmation;
    public subTitle: string;
    public footerNote: string;
    public showClose: boolean;
    constructor() { }

    public confirm(confirm: IConfirmation) {
        this.showPopup = true;
        this.header = confirm.header || 'Confirm';
        this.message = confirm.message || 'Are you sure?';
        this.confirmBtnText = confirm.confirmBtnText || '';
        this.rejectBtnText = confirm.rejectBtnText || '';
        this._confirm = confirm;
        this.subTitle = confirm.subTitle || '';
        this.footerNote = confirm.footerNote || '';
        this.showClose = !!confirm.showClose;
    }

    public onClose() {
        this.showPopup = false;
    }

    public onAccept() {
        this.showPopup = false;
        if (typeof this._confirm.accept === 'function') {
            this._confirm.accept();
        }
    }
    public onReject() {
        this.showPopup = false;
        if (typeof this._confirm.reject === 'function') {
            this._confirm.reject();
        }
    }
}
